import { render, staticRenderFns } from "./CountryMapCard.vue?vue&type=template&id=5d84e3a1"
import script from "./CountryMapCard.vue?vue&type=script&lang=js"
export * from "./CountryMapCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports